module.exports = __webpack_public_path__ + "img/map-bg.83bf2356.png";